"use client";

import { LocaleLink } from "@i18n/routing";
import { useRouter } from "@shared/hooks/router";
import { Button } from "@ui/components/button";
import { useTranslations } from "next-intl";
import { AI_MUSIC_PAGE_PATH } from "../config";
import type { MusicFormValues } from "../types";
import { MusicFeed } from "./MusicFeed";

/** My Assets 跳到音乐页时带过去的表单，工作台挂载时读一次就删 */
export const MUSIC_REUSE_STORAGE_KEY = "ai-music-reuse";

/** My Assets 的 Music tab：同一套歌曲卡片，Reuse 跳回音乐页回填 */
export function MusicAssets() {
	const t = useTranslations("aiMusic");
	const router = useRouter();

	const reuse = (values: MusicFormValues) => {
		try {
			sessionStorage.setItem(
				MUSIC_REUSE_STORAGE_KEY,
				JSON.stringify(values),
			);
		} catch {
			// 存不了（隐私模式等）就只跳页，不回填
		}
		router.push(AI_MUSIC_PAGE_PATH);
	};

	return (
		<div className="max-w-3xl">
			<MusicFeed
				onReuse={reuse}
				emptyState={
					<div className="flex justify-center">
						<Button asChild variant="primary">
							<LocaleLink href={AI_MUSIC_PAGE_PATH}>
								{t("cta.button")}
							</LocaleLink>
						</Button>
					</div>
				}
			/>
		</div>
	);
}
